import React from 'react';

const StagingEnvContext = React.createContext(false);

export const StagingEnvWrapper = ({ children, taskId = null }) => {
    const routeTaskId = route().params?.taskId;
const isMatch = routeTaskId
  ?.split(',')
  .map(id => id.trim())
  .includes(String(taskId));

    let ifChild = null;
    let elseChild = null;

    const childArray = React.Children.toArray(children);

    childArray.forEach(child => {
        if (child?.type === StagingEnvWrapper.Else) {
            elseChild = child;
        } else {
            ifChild = ifChild || child;
        }
    });

    return (
        <StagingEnvContext.Provider value={isMatch}>
            {isMatch ? ifChild : elseChild}
        </StagingEnvContext.Provider>
    );
};

StagingEnvWrapper.If = ({ children }) => {
    const isMatch = React.useContext(StagingEnvContext);
    return isMatch ? children : null;
};

StagingEnvWrapper.Else = ({ children }) => {
    const isMatch = React.useContext(StagingEnvContext);
    return !isMatch ? children : null;
};
